import Phaser from 'phaser';

export class PhysicsManager {
  public static configureWorld(scene: Phaser.Scene, width: number, height: number, gravityY = 980): void {
    scene.physics.world.setBounds(0, 0, width, height);
    scene.physics.world.gravity.y = gravityY;
  }
}
